import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { ProductTypes } from "../../../public/landingPage/components/productTypes";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { getPastOrderDataDetailsAsync } from "../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { useNavigate } from "react-router-dom";

export const OrderConfirmation = () => {
  const [localconfirmedOrder, setlocalconfirmedOrder] = useState({}) as any;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { profileData }: any = useAppSelector((state) => state.ProfileState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const orderInfoData = useAppSelector(
    (state) => state.CheckoutState.orderInfoData
  );

  useEffect(() => {
    const orderUUID = localStorage.getItem("order_uuid");
    if (orderUUID) {
      dispatch(getPastOrderDataDetailsAsync(orderUUID)).then(
        (response: any) => {
          if (response?.payload?.status === 200) {
            setlocalconfirmedOrder(response?.payload?.data?.order_details);
          }
        }
      );
    } else {
      const localconfirmedOrder2 = JSON.parse(
        localStorage.getItem("orderDetails") as any
      );
      setlocalconfirmedOrder(localconfirmedOrder2);
    }
  }, []);

  const convertTimeTo12HourFormat = (time: string): string => {
    if (!time) {
      return ""; // Return a fallback string if time is undefined or falsy
    }

    const [hours, minutes] = time.split(":").map(Number);
    const isPM = hours >= 12;
    const formattedHours = hours % 12 || 12; // Converts 00:00 to 12:00 for midnight
    const formattedMinutes = minutes?.toString().padStart(2, "0");
    const period = isPM ? "PM" : "AM";

    return `${formattedHours}:${formattedMinutes} ${period}`;
  };

  const convertDateToMMDDYYYY = (date: string): string => {
    let year, month, day;
    if (date) {
      [year, month, day] = date.split("-");
    }
    return year && month && day ? `${month}/${day}/${year}` : "";
  };

  const formatDateToMMDDYYYY = (date: string): string => {
    if (date !== "Invalid Date") {
      const d = new Date(date);

      const month = String(d?.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(d?.getDate()).padStart(2, "0");
      const year = d?.getFullYear();

      const hours24 = d?.getHours();
      const minutes = String(d?.getMinutes()).padStart(2, "0");

      // Convert to 12-hour format
      const isPM = hours24 >= 12;
      const hours12 = hours24 % 12 || 12; // 12 is for midnight and noon
      const period = isPM ? "PM" : "AM";

      return `${month}/${day}/${year} ${hours12}:${minutes} ${period}`;
    } else return "";
  };
  const orderDate = new Date(localconfirmedOrder?.created_date);
  return (
    <>
      <ResponsiveAppBar />
      <ProductTypes />
      <div className="tf-breadcrumb">
        <div className="container">
          <div className="tf-breadcrumb-wrap d-flex justify-content-between flex-wrap align-items-center">
            <div className="tf-breadcrumb-list">
              <a className="text" onClick={() => navigate("/")}>
                Home
              </a>
              <i className="icon icon-arrow-right"></i>
              <span className="text">My Order</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <div className="row">
          <div className="col-md-8">
            <div className="mb-3 confirm-order">
              <div className="row align-items-center justify-content-center">
                <div className="col-12 text-center">
                  {/* <img src="images/success.svg" width="50" alt=""> */}
                  {/* <CheckIcon color="success" /> */}
                  <CheckCircleIcon
                    style={{
                      color: "green", // Green filled circle
                      fontSize: "50px", // Size of the icon
                    }}
                  />
                  <h6 className="my-2">Confirmed</h6>
                  <p className="address-text">
                    <b>
                      Thank You !<br />
                      Your Order has been Placed. Order Id:{" "}
                      {localconfirmedOrder?.order_ID}
                    </b>
                  </p>
                </div>
              </div>
            </div>

            <div className="wd-form-order">
              <div className="tf-grid-layout md-col-2 gap-15 border-dotted">
                <div className="item">
                  <div className="d-flex">
                    <div className="orange-txt">
                      <LocationOnIcon />
                    </div>
                    <div className="ms-2">
                      <div className="text-2 text_black-2">
                        {localconfirmedOrder?.address_type
                          ?.toLowerCase()
                          .replace(/\b\w/g, (char: any) => char.toUpperCase())}
                      </div>
                      <div className="text-2 mt_4 fw-6">
                        {localconfirmedOrder?.address_1
                          ? localconfirmedOrder?.address_1 + ","
                          : ""}
                        {localconfirmedOrder?.address_2}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex mt-2">
                    <div className="orange-txt">
                      <PhoneIcon />
                    </div>
                    <div className="ms-2">
                      <div className="text-2 text_black-2">Phone</div>
                      <div className="text-2 mt_4 fw-6">
                        {profileData?.data?.phone_number}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="widget-content-inner mt-3">
                <h6>Order Status</h6>
                <div className="widget-timeline">
                  <ul className="timeline">
                    {localconfirmedOrder?.order_status === "Failed" ? (
                      <>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status === "Failed"
                                ? "timeline-badge primary"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <div className="text-2 fw-6">Order is Failed</div>
                            {/* <span>
                              {formatDateToMMDDYYYY(orderDate?.toString())}
                            </span> */}
                          </div>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status ===
                                "New Order" ||
                              localconfirmedOrder?.order_status === "Failed" ||
                              localconfirmedOrder?.order_status ===
                                "Confirmed" ||
                              localconfirmedOrder?.order_status === "Viewed" ||
                              localconfirmedOrder?.order_status ===
                                "Order Packed" ||
                              localconfirmedOrder?.order_status ===
                                "Delevery Assigned" ||
                              localconfirmedOrder?.order_status ===
                                "Dispatching" ||
                              localconfirmedOrder?.order_status === "Delivered"
                                ? "timeline-badge success"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <div className="text-2 fw-6">Order is Pending</div>
                            <span>
                              {formatDateToMMDDYYYY(orderDate?.toString())}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status ===
                                "Confirmed" ||
                              localconfirmedOrder?.order_status === "Viewed" ||
                              localconfirmedOrder?.order_status ===
                                "Order Packed" ||
                              localconfirmedOrder?.order_status ===
                                "Delevery Assigned" ||
                              localconfirmedOrder?.order_status ===
                                "Dispatching" ||
                              localconfirmedOrder?.order_status === "Delivered"
                                ? "timeline-badge success"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <div className="text-2 fw-6">Order is Placed</div>
                            {/* <span>
                              {formatDateToMMDDYYYY(orderDate?.toString())}
                            </span> */}
                          </div>
                        </li>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status === "Viewed" ||
                              localconfirmedOrder?.order_status ===
                                "Order Packed" ||
                              localconfirmedOrder?.order_status ===
                                "Delevery Assigned" ||
                              localconfirmedOrder?.order_status ===
                                "Dispatching" ||
                              localconfirmedOrder?.order_status === "Delivered"
                                ? "timeline-badge success"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <div className="text-2 fw-6">Order Accepted</div>
                            {/* <span>10/07/2024 4:30pm</span> */}
                          </div>
                        </li>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status ===
                                "Order Packed" ||
                              localconfirmedOrder?.order_status ===
                                "Delevery Assigned" ||
                              localconfirmedOrder?.order_status ===
                                "Dispatching" ||
                              localconfirmedOrder?.order_status === "Delivered"
                                ? "timeline-badge success"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <div className="text-2 fw-6">Order is Packed</div>
                            {/* <span>10/07/2024 4:30pm</span> */}
                          </div>
                        </li>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status ===
                                "Delevery Assigned" ||
                              localconfirmedOrder?.order_status ===
                                "Dispatching" ||
                              localconfirmedOrder?.order_status === "Delivered"
                                ? "timeline-badge success"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <a className="timeline-panel" href="#">
                              <div className="text-2 fw-6">
                                Out for Delivery
                              </div>
                              {/* <span>11/07/2024 2:36pm</span> */}
                            </a>
                          </div>
                        </li>
                        <li>
                          <div
                            className={
                              localconfirmedOrder?.order_status === "Delivered"
                                ? "timeline-badge success"
                                : "timeline-badge"
                            }
                          ></div>
                          <div className="timeline-box">
                            <a className="timeline-panel" href="#">
                              <div className="text-2 fw-6">Order Delivered</div>
                              <span>
                                {convertDateToMMDDYYYY(
                                  localconfirmedOrder?.delivery_slot_date
                                )}
                              </span>
                              &nbsp;
                              <span>
                                {convertTimeTo12HourFormat(
                                  localconfirmedOrder?.delivery_slot_time
                                )}
                              </span>
                            </a>
                          </div>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 modal-shopping-cart">
            <div className="wrap">
              <div className="tf-mini-cart-wrap card">
                <div className="tf-mini-cart-bottom">
                  <div className="tf-mini-cart-bottom-wrap">
                    <div style={{ margin: "10px" }}>
                      <h3>Bill Details</h3>
                      <div className="tf-cart-totals-discounts">
                        <div className="tf-cart-total">Item Total</div>
                        <div className="tf-totals-total-value fw-6">
                          ₹{localconfirmedOrder?.sub_total}{" "}
                        </div>
                      </div>
                      <div className="tf-cart-totals-discounts">
                        <div>Delivery Fee</div>
                        <div>{localconfirmedOrder?.delivery_charges}</div>
                      </div>
                      <hr />
                      {/* <div className="tf-cart-totals-discounts">
                        <div>Platform Fee</div>
                        <div>0.00</div>
                      </div> */}
                      <div className="tf-cart-totals-discounts">
                        <div>GST and Restaurant charges</div>
                        <div>
                          ₹
                          {localconfirmedOrder?.taxes_and_charges
                            ? Number(
                                localconfirmedOrder.taxes_and_charges
                              ).toFixed(2)
                            : "0.00"}
                        </div>
                      </div>
                      <hr />
                      <div className="tf-cart-totals-discounts">
                        <div className="tf-cart-total fw-6">Paid</div>
                        <div className="tf-totals-total-value fw-6">
                          ₹{localconfirmedOrder?.grand_total}{" "}
                        </div>
                      </div>
                      <div className="tf-mini-cart-view-checkout">
                        <div className="tf-btn  animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note">
                          <span>You have saved ₹85.15</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
